import { calculateOffsetFromPageAndLimit } from '../../CRM/shared/utils/pagination';
import { apiChatTS as http } from '../../../http';

class WhatsappBlockListService {
  constructor() {
    this.path = `/blocked-list`;
  }

  list(params, headers = { page: 1, limit: 10 }) {
    const offset = calculateOffsetFromPageAndLimit(headers.page, headers.limit);
    return http.get(this.path, {
      params,
      headers: {
        ...headers,
        offset
      }
    });
  }

  create(data) {
    return http.post(this.path, data);
  }

  update(id, data) {
    return http.put(`${this.path}/${id}`, data);
  }

  delete(id) {
    return http.delete(`${this.path}/${id}`);
  }

  getById(id) {
    return http.get(`${this.path}/${id}`);
  }

  async getReportTypeXlsx(params) {
    return http.get('/export-blocked-numbers-xlsx', {
      params,
      responseType: 'blob'
    });
  }

  async getReportTypeCSV(params) {
    return http.get('/export-blocked-numbers-csv', {
      params,
      responseType: 'blob'
    });
  }

  async importWhatsappBlockList(data) {
    return http.post('/import-blocked-numbers', data);
  }

  // reports:
  async listReport(params, headers = { page: 1, limit: 10 }) {
    const offset = calculateOffsetFromPageAndLimit(headers.page, headers.limit);
    return http.get('/blocked-list-log', {
      params,
      headers: {
        ...headers,
        offset
      }
    });
  }

  async getReportTypeXlsxReport(params) {
    return http.get('/export-blocked-numbers-log-xlsx', {
      params,
      responseType: 'blob'
    });
  }

  async getReportTypeCSVReport(params) {
    return http.get('/export-blocked-numbers-log-csv', {
      params,
      responseType: 'blob'
    });
  }

  // palavras bloqueadas:
  async listBlockedWords() {
    return http.get('/blocking-words');
  }

  async createBlockedWord(data) {
    return http.post('/blocking-words', data);
  }

  async updateBlockedWord(id, data) {
    return http.put(`/blocking-words/${id}`, data);
  }

  async deleteBlockedWord(id) {
    return http.delete(`/blocking-words/${id}`);
  }
}

export default new WhatsappBlockListService();
